import React, { useCallback, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import { useNavigate, Link } from "react-router-dom";
import "../../index.css";
import {
  setSelectedLabor,
  deleteLabor,
  setFinalData,
  updateLabour2,
} from "../../app/features/counter/counterSlice.js";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { ProductOptionsCsvData } from "../fetchData/ProductOptionsCsvData.js";
import { useSelector, useDispatch } from "react-redux";
import { CategoryCsvData } from "../fetchData/CategoryCsvData.js";
import { ProductCsvData } from "../fetchData/ProductCsvData.js";
import DisplayDrops from "./DisplayDrops.js";
import { updateComparisonData } from "../../app/features/counter/counterSlice.js";
import { toast } from "react-toastify";
import WarningComponent from "./WarningComponent.js";
import LaborWarningModal from "./LaborWarningModal.js";
import {
  calculateLineItem,
  getOptionEntries,
  mergeOptionPriceFields,
  DEFAULT_STANDARD_FIELDS,
  getProductSku,
  getProductDisplayName,
} from "./quoteCalculator";
import { SVC_CALL_CITY_ZONES } from "../../config/svcCallCityZones";
function Labor() {
  const areYouDealer = useSelector((state) => state.counter1.areYouDealer);
  const whichOption = useSelector(
    (state) => state.counter1.whichOptionSelected
  );

  const navigate = useNavigate();
  const selectedCameraNumber = useSelector(
    (state) => state.counter1.totalCamera
  );
  const selectedCameraItems = useSelector(
    (state) => state.counter1.selectedCamera || []
  );
  const customerData = useSelector((state) => state.counter1.customerData || {});
  const selectedDropsFromRedux = useSelector(
    (state) => state.counter1.selectedDrops || {}
  );
  const { productOptionCSVQuery, isLoading3, isError3 } =
    ProductOptionsCsvData();
  const [totalDrops, setTotalDrops] = useState(0);
  const [dropdownPrices, setDropdownPrices] = useState({});
  const [finalDatas, setFinalDatas] = useState([]);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);

  const totalSelectedCameras = useSelector((state) => {
    const cameras = state.counter1.selectedCamera;
    const filteredCameras = cameras.filter(
      (item) => item.num_options === whichOption
    );
    let total = 0;
    filteredCameras.forEach((item) => {
      if (item.Product_Quantity) {
        total += item.Product_Quantity;
      }
    });
    return total;
  });

  const [count, setCount] = useState("");
  const [basePrice, setBasePrice] = useState(0);
  const [basePrice1, setBasePrice1] = useState();
  const [unitCostInput, setUnitCostInput] = useState("");
  const [totalPrice, setTotalPrice] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const [filteredData, setfilteredData] = useState([]);
  const [categoryName, setCategoryName] = useState([]);
  const [filteredData2, setfilteredData2] = useState([]);
  const [categoryName2, setCategoryName2] = useState([]);
  const [finalNewState2, setFinalNewState2] = useState({});
  const [disableIt, setDisableIt] = useState("");
  const [updateVal, setUpdateVal] = useState();
  const dispatch = useDispatch();
  const [thumbimg, setThumbimg] = useState([]);
  const countLabor = useSelector((state) => state.counter1.selectedLabor);
  const totalNoOptions = useSelector((state) => state.counter1.totalNoOptions);
  const [showButtons, setShowButtons] = useState(null);
  const [showWarningComponent, setShowWarningComponent] = useState(false);
  const [laborMismatchDetails, setLaborMismatchDetails] = useState([]);
  const [showAutoLaborModal, setShowAutoLaborModal] = useState(false);

  // IncreDecre Count Value
  const [increDecreCount, setIncreDecreCount] = useState(1);
  const [totalCameraPrice, setTotalCameraPrice] = useState(0);
  const [totalPlanTypePrice, setTotalPlanTypePrice] = useState(0);

  const normalizeCsvValue = (value) => String(value || "").trim().toLowerCase();

  const splitCsvList = (value) =>
    String(value || "")
      .split(/[\/@|,]+/)
      .map((word) => normalizeCsvValue(word))
      .filter(Boolean);

  const hasExactCategory = (product, categoryName) =>
    splitCsvList(product && product.categories).includes(normalizeCsvValue(categoryName));

  const hasExactParent = (category, parentId) =>
    splitCsvList(category && category.category_parent).includes(normalizeCsvValue(parentId));


  const normalizeCityName = (value) =>
    String(value || "")
      .toLowerCase()
      .replace(/\b(city|village|town|township)\b/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();

  const getProductBasePrice = (product) =>
    Number(
      areYouDealer === "Dealer Selected"
        ? product?.price_2 || product?.price || 0
        : product?.price || product?.price_2 || 0
    ) || 0;

  const getCustomerCity = () =>
    String(customerData.shipCity || customerData.billCity || "").trim();

  const getCustomerSvcZone = () => {
    const normalizedCity = normalizeCityName(getCustomerCity());
    if (!normalizedCity) return "";
    return SVC_CALL_CITY_ZONES[normalizedCity] || "";
  };

  const isSvcCallItem = (item) =>
    String(item?.id || item?.Product_Name || item?.sku || "")
      .toUpperCase()
      .startsWith("SVC-CALL-");

  const isLaborStdProduct = (product) => hasExactCategory(product, "LABOR-STD");

  const getLaborStdProducts = () =>
    (productCSVQuery || [])
      .filter((product) => {
        if (!product || !isLaborStdProduct(product)) return false;
        if (areYouDealer === "Dealer Selected") return product.hide_2 === "0";
        return product.hide_1 === "0";
      })
      .sort((a, b) => (parseInt(a.sorting, 10) || 0) - (parseInt(b.sorting, 10) || 0));

  const getSvcCallProductForZone = (zoneLetter) => {
    const zone = String(zoneLetter || "").toUpperCase();
    if (!zone) return null;

    return (productCSVQuery || []).find((product) => {
      const sku = String(product?.id || "").toUpperCase();
      return sku.startsWith(`SVC-CALL-${zone}`);
    });
  };

  const getOptionCartItems = () =>
    (cartItems || []).filter((item) => String(item.num_options) === String(whichOption));

  const isDropQuantityLaborItem = (item) =>
    Number(String(item?.extra_field_3 || "").trim()) === 1;

  const isSvcCallLaborCostItem = (item) => {
    if (!item || isSvcCallItem(item)) return false;
    return Number(String(item?.extra_field_4 || "").trim()) === 1;
  };

  const getServiceCallLaborTotalForOption = (extraItems = []) =>
    [...getOptionCartItems(), ...extraItems].reduce((total, item) => {
      if (!isSvcCallLaborCostItem(item)) return total;
      return total + calculateLineItem(item).lineTotal;
    }, 0);

  const makeCartLineFromProduct = (product, quantity, categoryNameOverride) => {
    const unitPrice = getProductBasePrice(product);
    const safeQuantity = Math.max(1, Math.ceil(Number(quantity || 1)));
    return {
      id: product.id,
      num_options: whichOption,
      name: product.name,
      quantity: safeQuantity,
      pricePerItem: unitPrice,
      totalPriceForItem: unitPrice,
      uniqueID: Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
      category_name: categoryNameOverride || (isSvcCallItem(product) ? "SVC-Call" : "LABOR-STD"),
      typedValue: 0,
      extra_field_1: product.extra_field_1 || "",
      extra_field_2: product.extra_field_2 || "",
      extra_field_3: product.extra_field_3 || "",
      extra_field_4: product.extra_field_4 || "0",
      extra_field_5: product.extra_field_5 || "",
      thumbnail: product?.thumbnail || "",
      image1: product?.image1 || "",
      image2: product?.image2 || "",
      image3: product?.image3 || "",
      image4: product?.image4 || "",
    };
  };

  // UniverSal Data Starts
  const { categoryCSVQuery, isLoading1, isOnline, isError1 } =
    CategoryCsvData();
  const { productCSVQuery, isLoading2, isOnline2, isError2 } = ProductCsvData();
  // Unit Count Counter
  const [typedValue, setTypedValue] = useState(0);

  React.useEffect(() => {
    if (countLabor) {
      setCartItems(countLabor || []);
      let totalPrice = 0;
      countLabor.forEach((item) => {
        totalPrice += item.totalPriceForItem;
      });
      setTotalPrice(totalPrice);
    }
  }, [countLabor]);

  const laborData1 = categoryCSVQuery
    ? categoryCSVQuery.filter((item) => {
        return hasExactParent(item, "105");
      })
    : [];

  // Remove Blank Code
  const demoArr = [];
  if (productCSVQuery && laborData1) {
    productCSVQuery.forEach((item1) => {
      laborData1.forEach((item) => {
        if (item1.categories) {
          const testVariable = hasExactCategory(item1, item.category_name);
          if (areYouDealer === "Dealer Selected") {
            if (testVariable === true && item1.hide_2 === "0") {
              demoArr.push(item);
            }
          } else if (areYouDealer !== "Dealer Selected") {
            if (testVariable === true && item1.hide_1 === "0") {
              demoArr.push(item);
            }
          }
        }
      });
    });
  }

  const isDropCountLaborItem = (item) => {
    if (!item) return false;

    const sku = String(item.id || item.Product_Name || item.sku || "").toUpperCase();

    // Service-call/setup labor lines are billable labor, but they should not be
    // counted toward the one-labor-per-drop requirement.
    if (sku.startsWith("SVC-")) return false;

    return Number(String(item.extra_field_3 || "").trim()) === 1;
  };

  const getCameraQuantityForOption = (optionNumber) => {
    return (selectedCameraItems || []).reduce((total, item) => {
      if (String(item.num_options) !== String(optionNumber)) return total;
      return total + Number(item.Product_Quantity || item.quantity || 0);
    }, 0);
  };

  const getDropSource = () => {
    if (totalDrops && typeof totalDrops === "object") return totalDrops;
    if (selectedDropsFromRedux && typeof selectedDropsFromRedux === "object") {
      return selectedDropsFromRedux;
    }
    return {};
  };

  const getExpectedDropsForOption = (optionNumber) => {
    const dropSource = getDropSource();
    const optionDrops = dropSource[optionNumber];
    const numericDrops = Number(optionDrops);

    if (Number.isFinite(numericDrops) && numericDrops > 0) {
      return numericDrops;
    }

    return getCameraQuantityForOption(optionNumber);
  };

  const getLaborQuantityForOption = (optionNumber) => {
    return (cartItems || []).reduce((total, item) => {
      if (String(item.num_options) !== String(optionNumber)) return total;
      if (!isDropCountLaborItem(item)) return total;
      return total + Number(item.quantity || item.Product_Quantity || 0);
    }, 0);
  };

  const getAllLaborOptionNumbers = () => {
    const optionNumbers = new Set();

    if (totalNoOptions !== undefined && totalNoOptions !== null) {
      for (let i = 1; i <= Number(totalNoOptions || 0); i += 1) {
        optionNumbers.add(String(i));
      }
    }

    Object.keys(getDropSource()).forEach((option) => optionNumbers.add(String(option)));

    (selectedCameraItems || []).forEach((item) => {
      if (item.num_options !== undefined) optionNumbers.add(String(item.num_options));
    });

    (cartItems || []).forEach((item) => {
      if (item.num_options !== undefined) optionNumbers.add(String(item.num_options));
    });

    if (optionNumbers.size === 0 && whichOption) optionNumbers.add(String(whichOption));

    return Array.from(optionNumbers).sort((a, b) => Number(a) - Number(b));
  };

  const getLaborMismatchDetails = () => {
    return getAllLaborOptionNumbers()
      .map((optionNumber) => {
        const expectedDrops = getExpectedDropsForOption(optionNumber);
        const laborQuantity = getLaborQuantityForOption(optionNumber);

        // Ignore fully empty options.
        if (!expectedDrops && !laborQuantity) return null;

        if (laborQuantity === expectedDrops) return null;

        return {
          option: optionNumber,
          expectedDrops,
          laborQuantity,
          difference: Math.abs(laborQuantity - expectedDrops),
          direction: laborQuantity < expectedDrops ? "too low" : "too high",
        };
      })
      .filter(Boolean);
  };

  const getCurrentOptionDrops = () => getExpectedDropsForOption(whichOption);

  const checkLaborMismatch = () => {
    const mismatches = getLaborMismatchDetails();
    setLaborMismatchDetails(mismatches);

    if (mismatches.length > 0) {
      setShowWarningComponent(true);
      return false;
    }

    setShowWarningComponent(false);
    return true;
  };

  function filterUniqueObjects(arr, property) {
    const uniqueSet = new Set();
    return arr.filter((obj) => {
      const value = obj[property];
      if (uniqueSet.has(value)) {
        return false; // Duplicate, skip this object
      }
      uniqueSet.add(value);
      return true; // Unique object
    });
  }
  const laborData = filterUniqueObjects(demoArr, "id").sort((a, b) => {
    return (parseInt(a.sorting, 10) || 0) - (parseInt(b.sorting, 10) || 0);
  });
  // Remove Blank Code

  const handleButtonClick = (e, category_name) => {
    setUpdateVal(cartItems.pricePerItem);
    setCategoryName(category_name);
    setShow(true);

    const laborData2 = productCSVQuery.filter((item) => {
      if (item.categories) {
        const matchesCategory = hasExactCategory(item, category_name);
        if (areYouDealer === "Dealer Selected") {
          return item.hide_2 === "0" && matchesCategory;
        } else if (areYouDealer !== "Dealer Selected") {
          return item.hide_1 === "0" && matchesCategory;
        }
      }
      return false;
    });
    setfilteredData(
      laborData2?.sort((a, b) => ((parseInt(a.sorting, 10) || 0) - (parseInt(b.sorting, 10) || 0)))
    );
  };

  function modal_1(e, item, id, type) {
    setShowButtons(type);
    setShow2(true);
    setShow(false);

    // Reset relevant states when opening modal
    setDropdownPrices({});
    setFinalNewState2({});
    setFinalDatas([]);

    let laborData3;
    let originalItem = null;
    if (type === "edit") {
      // Find the exact item in cart using uniqueID
      originalItem = cartItems.find(
        (cartItem) =>
          cartItem.id === item.id &&
          cartItem.num_options === item.num_options &&
          cartItem.uniqueID === item.uniqueID
      );

      if (!originalItem) {
        console.error("Original item not found in cart");
        toast.error("Item not found in cart");
        setShow2(false);
        return;
      }

    

      // Get product data
      const laborData2 = productCSVQuery.filter((item1) => {
        if (item1.categories) {
          const matchesCategory = hasExactCategory(item1, item.category_name);

          if (areYouDealer === "Dealer Selected") {
            return item1.hide_2 === "0" && matchesCategory;
          } else if (areYouDealer !== "Dealer Selected") {
            return item1.hide_1 === "0" && matchesCategory;
          }
        }
        return false;
      });

      laborData3 = laborData2.filter((product) => product.id === id);

      // Auto-added SVC-Server/SVC-ENC/SVC-DIAG rows may not have the same
      // category_name metadata as manually selected Labor rows. Fall back to
      // a direct SKU lookup, then to the cart row itself, so edited quantities
      // can still be saved instead of silently failing to match a product.
      if (!laborData3.length) {
        const directProduct = (productCSVQuery || []).find(
          (product) => String(product?.id || "") === String(id || originalItem.id || "")
        );
        laborData3 = directProduct ? [directProduct] : [originalItem];
      }
    

      // Preserve the option values and prices from the original item
      const optionValues = {};
      const optionPrices = {};

      // Extract all dropdown options from the original item
      Object.keys(originalItem).forEach((key) => {
        // Check if this key represents a dropdown option (not a standard property)
        if (
          !DEFAULT_STANDARD_FIELDS.has(key) &&
          !key.endsWith("_price")
        ) {
          optionValues[key] = originalItem[key];

          let selectedPrice = Number(originalItem[`${key}_price`] || 0);

          if (!selectedPrice) {
            // Find the price for this option when older cart items did not store *_price
            const optionGroup = productOptionCSVQuery.filter(
              (opt) => opt.featurename === optionValues[key]
            );

            // Use a more robust comparison to find the selected option
            const selectedOption = optionGroup.find((opt) => {
              // Trim and normalize both strings for comparison
              const optFeatureName = opt.featurename
                ? opt.featurename.trim().toLowerCase()
                : "";
              const originalValue = originalItem[key]
                ? originalItem[key].toString().trim().toLowerCase()
                : "";

              return optFeatureName === originalValue;
            });

            selectedPrice = selectedOption
              ? parseFloat(selectedOption.featureprice) || 0
              : 0;
          }

          optionValues[key] = originalItem[key];
          optionValues[`${key}_price`] = selectedPrice;
          optionPrices[key] = selectedPrice;
        }
      });

      setUpdateVal(originalItem.pricePerItem);
      setBasePrice1(originalItem.pricePerItem);
      setCount(originalItem.quantity);
      setTypedValue(originalItem.typedValue || 0);
      setFinalNewState2(optionValues);
      setDropdownPrices(optionPrices);
    } else {
      setUpdateVal(0);
      setBasePrice1(0);
      setCount(1);
      setTypedValue(0);
      laborData3 = filteredData.filter((product) => product.id === id);
    }

    // Process product options
    let result = [];
    let currentArray = [];

    for (let i = 0; i < productOptionCSVQuery.length; i++) {
      const option = productOptionCSVQuery[i];
      if (
        option.productid === id ||
        (currentArray.length > 0 && option.productid === "")
      ) {
        currentArray.push(option);
      } else if (currentArray.length > 0) {
        result = currentArray;
        currentArray = [];
      }
    }

    if (currentArray.length > 0) {
      result = [...currentArray];
    }

    // Group options by feature
    const result1 = [];
    let currentArray1 = [];

    for (let i = 0; i < result.length; i++) {
      const option = result[i];
      if (option.productid === id) {
        if (currentArray1.length > 0) {
          result1.push([...currentArray1]);
          currentArray1 = [];
        }
        currentArray1.push(option);
      } else if (currentArray1.length > 0 || i === result.length - 1) {
        currentArray1.push(option);
      }
    }

    if (currentArray1.length > 0) {
      result1.push([...currentArray1]);
    }

    // Set option values - IMPORTANT: For edit mode, don't override the already set values
    if (result1.length > 0 && type !== "edit") {
      const initialState = {};
      result1.forEach((group) => {
        if (group[0] && group[0].featurecaption) {
          // Only set defaults for add mode, not edit mode
          initialState[group[0].featurecaption] = group[0].featurename;
          initialState[`${group[0].featurecaption}_price`] =
            parseFloat(group[0].featureprice) || 0;

          // Set default price for this dropdown if not already set
          if (!dropdownPrices[group[0].featurecaption]) {
            setDropdownPrices((prev) => ({
              ...prev,
              [group[0].featurecaption]: parseFloat(group[0].featureprice) || 0,
            }));
          }
        }
      });
      setFinalNewState2(initialState);
    }

    // Prepare the product data
    const itemData = laborData3[0] ? { ...laborData3[0] } : {};

    // Preserve existing properties when editing
    if (type === "edit") {
      itemData.uniqueID = item.uniqueID;
      itemData.quantity = item.quantity;
      itemData.pricePerItem = item.pricePerItem;
      itemData.typedValue = item.typedValue;
      itemData.category_name = item.category_name || itemData.category_name || itemData.categories || "Labor";
      itemData.category = item.category || itemData.category || "Labor";
    } else {
      itemData.uniqueID =
        Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
    }

    // Merge with option values
    const mergedState = [{ ...itemData, ...finalNewState2 }];

    // Set all states
    setFinalDatas(result1);
    setfilteredData2(mergedState);
    setCategoryName2(id);

    if (mergedState.length > 0) {
      setBasePrice(parseFloat(mergedState[0].price));

      // Initialize count properly
      const initialCount =
        type === "edit"
          ? item.quantity
          : isDropQuantityLaborItem(mergedState[0])
          ? getCurrentOptionDrops() || totalSelectedCameras || 1
          : 1;
      setCount(initialCount);
    } else {
      console.error("Product data not found for ID:", id);
      toast.error("Product data not found");
      setShow2(false);
    }
  }


  const openAutoLaborModal = () => {
    setShowAutoLaborModal(true);
  };

  const calculateServiceCalls = () => {
    const customerCity = getCustomerCity();
    const svcZone = getCustomerSvcZone();
    if (!customerCity) {
      toast.error("Enter a Billing City or Shipping City in Customer Info before calculating SVC-Call.");
      return;
    }
    if (!svcZone) {
      toast.error(`No SVC-Call zone was found for ${customerCity}.`);
      return;
    }

    const svcCallProduct = getSvcCallProductForZone(svcZone);
    if (!svcCallProduct) {
      toast.error(`No SVC-Call SKU was found for Zone ${svcZone}.`);
      return;
    }

    const onsiteHoursPerDay = Number(svcCallProduct.extra_field_1 || 0);
    if (!onsiteHoursPerDay || onsiteHoursPerDay <= 0) {
      toast.error(`${svcCallProduct.id} is missing extra_field_1 on-site hours/day.`);
      return;
    }

    const laborCost = getServiceCallLaborTotalForOption();
    if (!laborCost || laborCost <= 0) {
      toast.error("Add labor with extra_field_4 = 1 to this option before calculating SVC-Call.");
      return;
    }

    const manHours = laborCost / 110;
    const svcCallQuantity = Math.max(1, Math.ceil(manHours / onsiteHoursPerDay));
    const svcCallLine = makeCartLineFromProduct(svcCallProduct, svcCallQuantity, "SVC-Call");

    getOptionCartItems()
      .filter(isSvcCallItem)
      .forEach((item) => dispatch(deleteLabor({ name: item.id, option: item.num_options, uniqueID: item.uniqueID })));

    dispatch(setSelectedLabor(svcCallLine));
    dispatch(setFinalData(svcCallLine));

    setCartItems((prevCartItems) => [
      ...prevCartItems.filter(
        (item) => !(String(item.num_options) === String(whichOption) && isSvcCallItem(item))
      ),
      svcCallLine,
    ]);

    setShowAutoLaborModal(false);
    toast.success(
      `Calculated ${svcCallQuantity} ${svcCallProduct.id} service call${svcCallQuantity === 1 ? "" : "s"} from $${laborCost.toFixed(2)} of labor.`
    );
  };

  const handleClickPlus = () => {
    setCount(count + 1);
  };

  const handleClickMinus = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  const handlePlusClickByFive = () => {
    setCount(count + 5);
  };
  const handleMinusClickByTen = () => {
    if (count > 10) {
      setCount(count - 10);
    }
  };

  const handlePlusClickByTen = () => {
    setCount(count + 10);
  };

  const handleMinusClickByFive = () => {
    if (count > 5) {
      setCount(count - 5);
    }
  };

  useEffect(() => {
    const data = typedValue + (updateVal ? updateVal : basePrice);
    setBasePrice1(data);
  }, [basePrice, count, typedValue]);

  const handleDelete = (name, option, uniqueID) => {
    dispatch(deleteLabor({ name, option, uniqueID }));
    const findIndex = countLabor.findIndex(
      (item) => item.id === name && item.num_options === option
    );
    const updatedCartItems = [...cartItems];
    const itemToRemove = updatedCartItems[findIndex];
    const newTotalPrice = totalPrice - itemToRemove.totalPriceForItem;
    const updatedCart = updatedCartItems.filter(
      (item) => !(item.id === name && item.num_options === option)
    );
    setCartItems(updatedCart);
    setTotalPrice(newTotalPrice);
    setTotalDrops(0);
  };

  //warning modal
  const [lgShow, setLgShow] = useState(false);
  const laborNextPage = () => {
    if (LABOR_NUMBER < totalDrops) {
      setLgShow(true);
    } else {
      navigate("/cart");
    }
  };

  const addLabourButton = () => {
    if (totalNoOptions === undefined) {
      return toast.error("No options available.");
    }

    if (count === 0) {
      return toast.error("Can't select an item with 0 quantity");
    }

    const optionFields = mergeOptionPriceFields(finalNewState2, dropdownPrices);
    const previewCalc = calculateLineItem({
      pricePerItem: Number(basePrice1) || 0,
      quantity: count,
      ...optionFields,
    });

    const totalPriceForItem = previewCalc.unitTotal;
    const dataforProduct = filteredData2[0];

    // Quantity is defaulted when the labor product has extra_field_3 = 1.
    // extra_field_4 is reserved for including the labor cost in SVC-Call calculations.
    const defaultQuantity = count;

    const newItem = {
      id: dataforProduct.id,
      num_options: whichOption,
      name: dataforProduct.name,
      quantity: defaultQuantity,
      pricePerItem: basePrice1,
      totalPriceForItem: totalPriceForItem,
      uniqueID:
        Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
      category_name: dataforProduct.category_name || categoryName || dataforProduct.categories || "Labor",
      typedValue: typedValue,
      extra_field_1: dataforProduct.extra_field_1 || "",
      extra_field_2: dataforProduct.extra_field_2 || "",
      extra_field_3: dataforProduct.extra_field_3 || "",
      extra_field_4: dataforProduct.extra_field_4 || "0",
      extra_field_5: dataforProduct.extra_field_5 || "",
      thumbnail: dataforProduct?.thumbnail || "",
      image1: dataforProduct?.image1 || "",
      image2: dataforProduct?.image2 || "",
      image3: dataforProduct?.image3 || "",
      image4: dataforProduct?.image4 || "",
    };

    if (
      dataforProduct.extra_field_2 !== undefined &&
      dataforProduct.extra_field_2 !== ""
    ) {
      newItem.drop = parseFloat(dataforProduct.extra_field_2);
    }

    const mergedState = { ...newItem, ...optionFields };
    dispatch(setSelectedLabor(mergedState));
    dispatch(setFinalData(mergedState));
    setCartItems((prevCartItems) => [...prevCartItems, mergedState]);
    setTotalPrice((prevTotalPrice) => (prevTotalPrice = +totalPriceForItem));
    setCount(defaultQuantity);
    setBasePrice(0);
    setShow2(false);
    setTypedValue(0);
    setTotalDrops(0);
    setDropdownPrices({});
  };

  // Update Button
  function updateLabor() {
    const optionFields = mergeOptionPriceFields(finalNewState2, dropdownPrices);
    const previewCalc = calculateLineItem({
      pricePerItem: Number(basePrice1) || 0,
      quantity: count,
      ...optionFields,
    });

    const totalPriceForItem = previewCalc.unitTotal;
    const dataforProduct = filteredData2[0];

    const quantityNew = count;
    const newItem2 = {
      id: dataforProduct.id,
      uniqueID: dataforProduct.uniqueID,
      num_options: whichOption,
      name: dataforProduct.name,
      quantity: quantityNew,
      pricePerItem: basePrice1,
      totalPriceForItem: totalPriceForItem,
      category_name: dataforProduct.category_name || categoryName || dataforProduct.categories || "Labor",
      typedValue: typedValue,
      extra_field_1: dataforProduct.extra_field_1 || "",
      extra_field_2: dataforProduct.extra_field_2 || "",
      extra_field_3: dataforProduct.extra_field_3 || "",
      extra_field_4: dataforProduct.extra_field_4 || "",
      extra_field_5: dataforProduct.extra_field_5 || "",
      ...optionFields,
    };

    if (dataforProduct.drop !== undefined) {
      newItem2.drop = dataforProduct.drop;
    }
    dispatch(updateLabour2(newItem2));
    setShow2(false);
    setCount(quantityNew);
    setTypedValue(0);
    setTotalDrops(0);
    setDropdownPrices({});
  }

  // Increased by $1
  function IncreaseByDollar_One() {
    setTypedValue((prev) => prev + 1);
  }

  // Decreased by $1
  function DecreaseByDollar_One() {
    if (typedValue > 0) {
      setTypedValue((prev) => prev - 1);
    }
  }

  const typedOnChange = (e) => {
    const value = e.target.value;

    if (/^\d*(\.\d{0,2})?$/.test(value)) {
      setUnitCostInput(value);
      const numericValue = value === "" || value === "." ? 0 : parseFloat(value);
      setUpdateVal(numericValue);
      setBasePrice1(numericValue);
    }
  };

  const typedIncrement = () => {
    setUnitCostInput("");
    setTypedValue((prevValue) => (prevValue > 0 ? prevValue + 1 : 0));
    setUpdateVal(basePrice1 + 1);
    setBasePrice1((prev) => prev + 1);
  };

  const typedDecrement = () => {
    setUnitCostInput("");
    setTypedValue((prevValue) => (prevValue > 0 ? prevValue - 1 : 0));
    setUpdateVal(basePrice1 - 1);
    setBasePrice1((prev) => prev - 1);
  };

  //filter table data based on num_option selected
  const filterData = cartItems.filter(
    (item) => item.num_options === whichOption
  );

  useEffect(() => {
    let numberOfLabors = 0;
    filterData.forEach((item) => {
      if (isDropCountLaborItem(item)) {
        numberOfLabors += Number(item?.quantity || item?.Product_Quantity || 0);
      }
    });

    if (whichOption && totalNoOptions !== undefined) {
      dispatch(
        updateComparisonData({
          [whichOption]: {
            name: "Labors",
            quantity: numberOfLabors || 0,
            warning: getCurrentOptionDrops(),
            option: whichOption,
            navigationName: "/labor",
          },
        })
      );
    }
  }, [filterData, whichOption, totalDrops, totalSelectedCameras, totalNoOptions]);

  const accessDrops = useCallback((drop) => {
    setTotalDrops((prevDrops) => {
      const previousSignature = JSON.stringify(prevDrops || {});
      const nextSignature = JSON.stringify(drop || {});

      if (previousSignature === nextSignature) {
        return prevDrops;
      }

      return drop || {};
    });
  }, []);

  function handleSelectChange(e) {
    const { name, value } = e.target;
    const selectedOption = finalDatas
      .flat()
      .find((option) => option.featurename === value);
    setDisableIt(selectedOption.featurename);

    // Update the price for this dropdown
    const optionPrice = selectedOption
      ? parseFloat(selectedOption.featureprice)
      : 0;

    setDropdownPrices((prev) => ({
      ...prev,
      [name]: optionPrice,
    }));

    setFinalNewState2((prevData) => ({
      ...prevData,
      [name]: value,
      [`${name}_price`]: optionPrice,
    }));
  }

  // Calculate total price including all dropdown options
  const getTotalPrice = () => {
    const optionFields = mergeOptionPriceFields(finalNewState2, dropdownPrices);
    const calc = calculateLineItem({
      pricePerItem: Number(basePrice1) || 0,
      quantity: Number(count) || 0,
      ...optionFields,
    });

    return calc.lineTotal.toFixed(2).replace(/\.?0+$/, "");
  };

  const formatCurrency = (value) => {
    const num = Number(value);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };
  return (
    <>
      <Container fluid className="my-4" style={{ backgroundColor: "" }}>
        <Container className="navbar_margin">
          <Row style={{ backgroundColor: "" }}>
            <Col style={{ backgroundColor: "" }} className="marginTopSpace">
              <h2>
                Labor <span className="fst-italic fs-6">(Category)</span>
              </h2>
            </Col>
            <Col className="marginTopSpace" style={{ backgroundColor: "" }}>
              <Row>
                <Col className="text-end">
                  Total Cameras Selected:{" "}
                  <span className="fw-bold">{totalSelectedCameras}</span>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  Total number of drops :{" "}
                  <span className="fw-bold">
                    {totalDrops[whichOption] === undefined
                      ? 0
                      : totalDrops[whichOption] === 0
                      ? totalSelectedCameras
                      : totalDrops[whichOption]}
                  </span>
                  {totalDrops === 0 ? (
                    <DisplayDrops
                      accessDrops={accessDrops}
                      runAccessDrops={"runAccessDrops"}
                    />
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
              <Row style={{ backgroundColor: "" }}>
                <Col className="text-end">
                  <Link to="/" className="remove_padding">
                    <h6>
                      Edit here <span className="fw-bold"></span>
                    </h6>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="" style={{ padding: "8px" }}>
            <Col>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 className="fw-bold mb-0">Add to Cart: </h5>
              </div>
              <div className="table-border">
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>SKU: </th>
                      <th>Description & Options: </th>
                      <th>Price: </th>
                      <th>QTY: </th>
                      <th>Total: </th>
                      <th colSpan={2} className="text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filterData.map((item, index) => {
                      const uniqueKey = `${item.id}-${index}`;
                      return (
                        <tr key={uniqueKey}>
                          <td>{getProductSku(item)}</td>
                          <td>
                            <strong>{getProductDisplayName(item)}</strong>
                            <br />
                            {getOptionEntries(item).map((option) => (
                              <React.Fragment key={option.name}>
                                <strong>{option.name}:</strong>{" "}
                                {option.value}{" "}
                                <strong>${Number(option.price || 0).toFixed(2)}</strong>
                                <br />
                              </React.Fragment>
                            ))}
                          </td>
                          <td>${calculateLineItem(item).unitTotal.toFixed(2)}</td>
                          <td>{item.quantity}</td>
                          <td>${calculateLineItem(item).lineTotal.toFixed(2)}</td>

                          <td>
                            <Button
                              variant="dark"
                              className="mx-4"
                              onClick={(e) => modal_1(e, item, item.id, "edit")}
                            >
                              Edit
                            </Button>
                          </td>
                          <td>
                            <Button
                              variant="dark"
                              onClick={() =>
                                handleDelete(
                                  item.id,
                                  item.num_options,
                                  item.uniqueID
                                )
                              }
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>

          <div className="d-flex justify-content-end align-items-center gap-2">
            {showWarningComponent && (
              <LaborWarningModal
                path="/cart"
                setShowWarningComponent={setShowWarningComponent}
                mismatchDetails={laborMismatchDetails}
              />
            )}

            <Button
              className="text-center"
              variant="success"
              onClick={openAutoLaborModal}
            >
              Add Service Calls
            </Button>

            <Button
              className="text-center"
              variant="dark"
              onClick={() => {
                if (checkLaborMismatch()) {
                  navigate("/cart");
                }
              }}
            >
              Next
            </Button>
          </div>

          <Row className="my-4" style={{ backgroundColor: "" }}>
            {laborData.map((item, index) => {
              return (
                <Col
                  key={index}
                  md={4}
                  className="mb-4"
                  onClick={(e) => handleButtonClick(e, item.category_name)}
                >
                  <Card style={{ width: "", margin: "" }}>
                    <Card.Body>
                      <Row
                        style={{
                          height: "185px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Col xs={7}>
                          <Card.Img
                            variant="top"
                            style={{
                              width: "100%",
                              height: "auto",
                              border: "0px solid grey",
                            }}
                            src={
                              item.iconimage === ""
                                ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                                : "https://platinumcctv.com/" + item.iconimage
                            }
                          />
                        </Col>
                        <Col
                          xs={5}
                          className=" align-items-center justify-content-center fw-bold"
                        >
                          <Card.Text className="fs-6">
                            {item.category_name}
                          </Card.Text>
                          <p className="camera_category_title">
                            {item.category_title || item.category_name}
                            <br />
                            {item.category_description.split(" ").length > 12
                              ? `${item.category_description
                                  .split(" ")
                                  .slice(0, 12)
                                  .join(" ")}...`
                              : item.category_description}
                          </p>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>


          <Modal
            size="lg"
            aria-labelledby="auto-labor-modal-title"
            centered
            show={showAutoLaborModal}
            onHide={() => setShowAutoLaborModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title id="auto-labor-modal-title">
                Calculate Service Calls
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                Add the needed labor to this option first. This will calculate the SVC-Call from the Customer Info city
                and the current cart labor lines that have extra_field_4 = 1.
              </p>
              <Row className="mb-3">
                <Col md={4}>
                  <strong>Option drops:</strong> {getCurrentOptionDrops() || totalSelectedCameras || 0}
                </Col>
                <Col md={4}>
                  <strong>Customer city:</strong> {getCustomerCity() || "Not entered"}
                </Col>
                <Col md={4}>
                  <strong>SVC Zone:</strong> {getCustomerSvcZone() || "Not found"}
                </Col>
              </Row>
              {(() => {
                const svcZone = getCustomerSvcZone();
                const svcCallProduct = getSvcCallProductForZone(svcZone);
                const hoursPerDay = Number(svcCallProduct?.extra_field_1 || 0);
                const laborCost = getServiceCallLaborTotalForOption();
                const manHours = laborCost / 110;
                const serviceCalls = hoursPerDay > 0 && laborCost > 0 ? Math.max(1, Math.ceil(manHours / hoursPerDay)) : 0;
                return (
                  <div className="border rounded p-3 bg-light">
                    <div><strong>Selected SVC-Call SKU:</strong> {svcCallProduct?.id || "None"}</div>
                    <div><strong>On-site hours/day:</strong> {hoursPerDay || "N/A"}</div>
                    <div><strong>Labor cost used for SVC-Call calculation:</strong> ${laborCost.toFixed(2)}</div>
                    <div><strong>Estimated man-hours:</strong> {manHours.toFixed(2)}</div>
                    <div><strong>SVC-Call quantity:</strong> {serviceCalls || "N/A"}</div>
                  </div>
                );
              })()}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowAutoLaborModal(false)}>
                Cancel
              </Button>
              <Button variant="dark" onClick={calculateServiceCalls}>
                Add Service Calls
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={() => setShow(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>{categoryName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="my-4">
                {filteredData.map((item, index) => {
                  const uniqueNumber = `${item.id}-${index}`;
                  return (
                    <Col
                      key={uniqueNumber}
                      md={4}
                      className="nvr_col my-2"
                      onClick={(e) => modal_1(e, item, item.id, "add")}
                    >
                      <Card
                        style={{
                          width: "",
                          backgroundColor: "",
                          height: "300px",
                        }}
                      >
                        <Card.Body>
                          <Card.Title className="fw-bold">
                            SKU : {item.id}
                          </Card.Title>
                          <Card.Text>
                            {item.name?.split(" ").slice(0, 10).join(" ")}...
                          </Card.Text>

                          <Row>
                            <Col xs={8}>
                              <Card.Img
                                variant="top"
                                height={100}
                                src={
                                  item.thumbnail === ""
                                    ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                                    : "https://platinumcctv.com/" +
                                      item.thumbnail
                                }
                              />
                            </Col>
                            <Col
                              xs={4}
                              className="d-flex align-items-center justify-content-center fw-bold"
                            >
                              $ {item.price}
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="dark" onClick={() => setShow(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show2}
            onHide={() => setShow2(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>{categoryName2}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Container>
                <Row>
                  {filteredData2.map((val, index) => {
                    const uniqueNo = `${val.id}-${index}`;
                    return (
                      <React.Fragment key={uniqueNo}>
                        <Col md={5}>
                          <Row>
                            <Card.Img
                              variant="top"
                              height={150}
                              src={
                                val.thumbnail === ""
                                  ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                                  : "https://platinumcctv.com/" + val.thumbnail
                              }
                            />
                          </Row>
                          <Row className="my-2">
                            {[
                              val.image1,
                              val.image2,
                              val.image3,
                              val.image4,
                            ].map((img, imgIndex) => {
                              const uniqueImgKey = `${imgIndex}-${val.id}`;
                              return (
                                <Col key={uniqueImgKey}>
                                  <Card.Img
                                    variant="top"
                                    height={40}
                                    className="camera_thumbnail_img"
                                    src={
                                      img === ""
                                        ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                                        : "https://platinumcctv.com/" + img
                                    }
                                    onClick={() =>
                                      setThumbimg({
                                        img1:
                                          index === 3
                                            ? "https://platinumcctv.com/" +
                                              image4
                                            : "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png",
                                      })
                                    }
                                  />
                                </Col>
                              );
                            })}
                          </Row>
                        </Col>
                        <Col md={7}>
                          <p className="fst-italic">
                            <span className="fw-bold">Description: </span>
                            {val.description ? val.description : val.categories}
                          </p>
                          {finalDatas.map((item, index) => (
                            <React.Fragment
                              key={item[0].featurecaption || index}
                            >
                              <Form.Label>{item[0].featurecaption}</Form.Label>
                              <Form.Select
                                aria-label="Default select example"
                                className="mb-3"
                                name={item[0].featurecaption}
                                value={
                                  finalNewState2[item[0].featurecaption] || ""
                                }
                                onChange={handleSelectChange}
                              >
                                {item.map((option, optionIndex) => (
                                  <option
                                    key={optionIndex}
                                    value={option.featurename}
                                  >
                                    {option.featurename +
                                      " $ " +
                                      option.featureprice}
                                  </option>
                                ))}
                              </Form.Select>
                            </React.Fragment>
                          ))}
                          <div
                            className="d-flex align-items-end justify-content-between my-4"
                            style={{ backgroundColor: "" }}
                          >
                            Qty:
                            <Button
                              variant="dark"
                              onClick={handleMinusClickByTen}
                            >
                              -10
                            </Button>
                            <Button
                              variant="dark"
                              onClick={handleMinusClickByFive}
                            >
                              -5
                            </Button>
                            <Button variant="dark" onClick={handleClickMinus}>
                              -
                            </Button>
                            <h6 className="mx-3">
                              {count ? count : totalSelectedCameras}
                            </h6>
                            <Button variant="dark" onClick={handleClickPlus}>
                              +
                            </Button>
                            <Button
                              variant="dark"
                              onClick={handlePlusClickByFive}
                            >
                              +5
                            </Button>
                            <Button
                              variant="dark"
                              onClick={handlePlusClickByTen}
                            >
                              +10
                            </Button>
                          </div>

                          {/*  Unit Cost Div */}

                          <hr />

                          <div className=" d-flex align-items-center justify-content-end">
                            Unit Cost :
                            <InputGroup className="mb-3">
                              <Button variant="dark" onClick={typedDecrement}>
                                -1
                              </Button>

                              <Form.Control
                                type="text"
                                value={unitCostInput !== "" ? unitCostInput : basePrice1}
                                onFocus={() => setUnitCostInput(String(basePrice1 ?? ""))}
                                onBlur={() => setUnitCostInput("")}
                                onChange={typedOnChange}
                              />
                              <Button onClick={typedIncrement} variant="dark">
                                +1
                              </Button>
                            </InputGroup>
                          </div>

                          {/* Total Price Div */}
                          <div className="text-end mt-3">
                            <h5>Total : $ {getTotalPrice()} </h5>
                          </div>
                        </Col>
                      </React.Fragment>
                    );
                  })}
                </Row>
              </Container>
            </Modal.Body>

            <Modal.Footer>
              <div className="w-100 my-4 d-flex align-items-end justify-content-between">
                <Button
                  className="mx-3"
                  variant="dark"
                  onClick={() => setShow2(false)}
                >
                  Back
                </Button>

                {showButtons === "edit" ? (
                  <Button variant="dark" onClick={updateLabor}>
                    Update Item
                  </Button>
                ) : (
                  <Button variant="dark" onClick={addLabourButton}>
                    Add
                  </Button>
                )}
              </div>
            </Modal.Footer>
          </Modal>

          <Modal show={lgShow} onHide={() => setLgShow(false)}>
            <Modal.Header closeButton>
              <Modal.Title>
                <h6> Warning ! Labor Count is less than Drops </h6>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>Are you sure want to continue ?</Modal.Body>
            <Modal.Footer>
              <Button variant="dark" onClick={() => setLgShow(false)}>
                No
              </Button>
              <Button variant="dark" onClick={() => navigate("/pdf")}>
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </Container>
    </>
  );
}

export default Labor;
